export default {"src":"/_next/static/image/public/images/ic_delivered.4ad69275f40f006756588b8d791d8f11.svg","height":53,"width":57};